.switch {
	display: inline-flex;
	position: relative;
	width: 2.5rem;
	height: 1.5rem;
}

.input {
	position: absolute;
	opacity: 0;
	width: 100%;
	height: 100%;
	margin: 0;

	&:disabled {
		cursor: not-allowed;

		&[data-loading] {
			cursor: wait;
		}
	}
}

.track {
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
	border-radius: 1rem;
	corner-shape: round;
	background-color: var(--color-border);
	transition: background-color 150ms ease;
	pointer-events: none;

	.input:checked + & {
		background-color: var(--color-primary);
	}

	.input:hover:not(:disabled) + & {
		background-color: var(--color-border-hover);
	}

	.input:checked:hover:not(:disabled) + & {
		background-color: var(--color-primary-hover);
	}

	.input:focus-visible + & {
		outline: var(--size-outline) solid var(--color-outline);
		outline-offset: var(--size-outline);
	}

	.input:disabled + & {
		opacity: 0.5;
	}
}

.thumb {
	width: 1.125rem;
	height: 1.125rem;
	border-radius: 50%;
	corner-shape: round;
	background-color: var(--color-surface);
	box-shadow: var(--shadow-sm);
	transform: translateX(0.1875rem);
	transition: transform 150ms ease;

	.input:checked ~ .track > & {
		transform: translateX(1.1875rem);
	}
}
